export const calendarSmcLocalStorageKey = 'scheduler_calendar_smc_active';
export const calendarFoLocalStorageKey = 'scheduler_calendar_fo_active';
export const calendarBttpLocalStorageKey = 'scheduler_calendar_bttp_active';
export const calendarTimeSlotsLocalStorageKey = 'scheduler_calendar_time_slots_active';

type CalendarFilterLocalStorageKeyType =
    | typeof calendarSmcLocalStorageKey
    | typeof calendarFoLocalStorageKey
    | typeof calendarBttpLocalStorageKey
    | typeof calendarTimeSlotsLocalStorageKey;

const defaultValue = true;

export const getCalendarFilterLocalStorage = (
    localStorageKey: CalendarFilterLocalStorageKeyType
) => {
    const valueLocalStorage = localStorage.getItem(localStorageKey);
    return valueLocalStorage ? Boolean(Number(valueLocalStorage)) : defaultValue;
};

export const setCalendarFilterLocalStorage = (
    localStorageKey: CalendarFilterLocalStorageKeyType,
    calendarFilter: boolean
) => {
    if (calendarFilter === defaultValue) {
        localStorage.removeItem(localStorageKey);
        return;
    }
    localStorage.setItem(localStorageKey, JSON.stringify(Number(calendarFilter)));
};
